import yup from "src/validators/yup.Module";

export interface LogoIncluirDto {
  arquivo: Blob[];
}

export const LogoIncluirSchema = yup.object().shape({
  arquivo: yup
    .mixed()
    .test("is-file-list", "Selecione a imagem", (value) => {
      return value && value instanceof FileList && value.length > 0;
    })
    .required("Selecione a imagem"),
});
